import readXlsxFile from 'read-excel-file'

function isValidPhone(phone) {
    return /^(09|989)([0-9]|[۰-۹]){9}$/.test(phone)
}

async function readPhoneNumbersFromXlsxFile(file){
    let numbers = []
    let rows = await readXlsxFile(file)
    for (let row of rows){
        for (let cell of row){
            numbers.push(cell.toString())
        }
    }

    return numbers;
}

function readPhoneNumbersFromCsvFile(file, callback){
    let ret = []

    let filereader = new FileReader()

    filereader.onload = function () {
        let numbers = filereader.result.split(',')
        for (let number of numbers){
            ret.push(number.toString())
        }
        callback(ret)
    }

    filereader.readAsText(file)
}


function formatToIranianPhone(phone) {
    phone = phone.trim()
    if (phone.startsWith("+98")) {
        phone = phone.substring(1)
    } else if (phone.startsWith('09')) {
        phone = '98' + phone.substring(1)
    } else if (phone.length === 10) {
        phone = "98" + phone;
    }

    return phone
}

async function validateNumbers(numbers){
    let valid = []
    let invalid = []

    for (let number of numbers){
        if (isValidPhone(number)){
            valid.push(number)
        }else{
            invalid.push(number)
        }
    }

    return {valid , invalid}
}


async function filterCorrectPhoneNumbers(numbers) {
    let arr = numbers?.filter(item => {
        return isValidPhone(formatToIranianPhone(item))
    }).map(item => formatToIranianPhone(item))

    return [...new Set(arr)]
}


export {
    isValidPhone,
    readPhoneNumbersFromXlsxFile,
    readPhoneNumbersFromCsvFile,
    validateNumbers,
    formatToIranianPhone,
    filterCorrectPhoneNumbers
}